function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

DOMready(function(){
    const menuToggle = document.querySelector('.menu-toggle');
    const headerMenu = document.querySelector('.header-menu');

    const show = () => {
        menuToggle.setAttribute('aria-expanded', true)
        headerMenu.classList.remove('header-menu--hidden');
    }

    const hide = () => {
        menuToggle.setAttribute('aria-expanded', false);
        headerMenu.classList.add('header-menu--hidden');
    }

    menuToggle.addEventListener('click', event => {
        event.stopPropagation();
        JSON.parse(menuToggle.getAttribute('aria-expanded')) ? hide() : show();
    })

    window.addEventListener('click', event => {
        !headerMenu.contains(event.target) && hide();
    });

    document.querySelector('.js-drawer-open-cart').addEventListener('click', event => {
        !headerMenu.contains(event.target) && hide();
    })

    function scrollIntoView(selector) {
        const element = document.querySelector( selector );
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    window.scrollFunc = scrollIntoView;
});
